<template>
  <card class="pt-3 pb-3">
    <radio-list
      :name="'status-filter'"
      @change="setStatus"
      :items="listState"
      :value="params.status"
    />
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :itemLink="itemLink"
      :params="params"
      @change="change"
    />
  </card>
</template>

<script>
import List from "../components/List";
/**Меняю добавление модалку */
import RadioList from "../components/Filters/RadioList";
import { mapState } from "vuex";
export default {
  name: "groups",
  components: {
    List,
    RadioList,
  },
  data() {
    return {
      params: {
        status: 1,
      },
      /**Меняю ссылки на модель */
      modalCreate: "orders",
      removeLink: "group/remove",
      cardLink: "order",
      itemLink: "admin/orders",
      /**Табличные филды */
      columns: [
        {
          key: "id",
          title: "ID заказа",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "id",
          title: "",
          checkbox: false,
          control: false,
          align: "left",

          link: "https://admin.glamourboutique.uz/#/orders?card=order&id=",
        },
        {
          key: "state",
          title: "Статус",
          checkbox: false,
          control: false,
          align: "left",
          detail: true,
        },
        {
          key: "",
          title: "",
          checkbox: true,
          control: "info",
          align: "left",
        },
        {
          key: "created_at",
          title: "Дата и время",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "before_at",
          title: "Осталось времени",
          checkbox: false,
          control: false,
          align: "left",
          timer: true,
        },

        {
          key: "format_display",
          title: "Формат связи",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "name",
          title: "Клиент",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "phone",
          title: "Контактный номер",
          checkbox: false,
          control: false,
          align: "right",
        },
      ],
      value: null,
    };
  },
  methods: {
    setStatus(val) {
      this.params.status = val;
      this.params.updatedAt = Date.now();
    },
    changeFunction(val) {},
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
  computed: {
    ...mapState(["listState"]),
  },
};
</script>
<style>
</style>
